<mat-form-field appearance="fill" class="mat-date-form-field">
  <mat-label>Date Range: {{ dateFormat?.label }}</mat-label>
  <mat-date-range-input
    [rangePicker]="picker"
    #dateRangeInput
    [dateFilter]="dateFilter"
  >
    <input matStartDate matInput [value]="startDate" />
    <input matEndDate matInput [value]="endDate" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon>
      <sh-icon icon="calendar" size="s"></sh-icon>
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-date-range-picker
    #picker
    [id]="pickerId"
    color="primary"
    (closed)="onDateChange(dateRangeInput.value)"
  ></mat-date-range-picker>
</mat-form-field>
